import { createMMKV } from 'react-native-mmkv';
import { parseJSON } from 'src/utils/json';
export default function createJSONStorage(configuration) {
    const storage = createMMKV(configuration);
    return {
        set(key, value) {
            storage.set(key, JSON.stringify(value));
        },
        get(key) {
            const value = storage.getString(key);
            return typeof value === 'string' ? parseJSON(value) : value;
        },
        delete(key) {
            return storage.remove(key);
        },
        clearAll() {
            storage.clearAll();
        },
        contains(key) {
            return storage.contains(key);
        },
        getAllKeys() {
            return storage.getAllKeys();
        },
        addOnValueChangedListener(onValueChanged) {
            return storage.addOnValueChangedListener(onValueChanged);
        },
    };
}
